module.exports = __webpack_public_path__ + "static/media/favicon.74d48c58.ico";